export default __webpack_public_path__ + "static/media/06__o_3.edae149c.jpg";